import React from "react";
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Icon = ({ children }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

const links = [
  {
    to: "/admin",
    end: true,
    label: "Dashboard",
    icon: (
      <Icon>
        <rect x="3" y="3" width="7" height="9" rx="1.5" />
        <rect x="14" y="3" width="7" height="5" rx="1.5" />
        <rect x="14" y="12" width="7" height="9" rx="1.5" />
        <rect x="3" y="16" width="7" height="5" rx="1.5" />
      </Icon>
    ),
  },
  {
    to: "/create",
    label: "Create QR Code",
    icon: (
      <Icon>
        <rect x="3" y="3" width="18" height="18" rx="4" />
        <path d="M12 8v8M8 12h8" />
      </Icon>
    ),
  },
  {
    to: "/admin/qrcodes",
    label: "All QR Codes",
    icon: (
      <Icon>
        <rect x="3" y="3" width="7" height="7" rx="1" />
        <rect x="14" y="3" width="7" height="7" rx="1" />
        <rect x="3" y="14" width="7" height="7" rx="1" />
        <path d="M14 14h3v3h-3zM20 14v.01M14 20h3M20 17v4" />
      </Icon>
    ),
  },
  {
    to: "/admin/analytics",
    label: "Analytics",
    icon: (
      <Icon>
        <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
      </Icon>
    ),
  },
  {
    to: "/admin/users",
    label: "Users",
    icon: (
      <Icon>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </Icon>
    ),
  },
];

export default function AdminSidebar() {
  const { isAdmin } = useAuth();
  // Managers ("marketing user") only get Dashboard + Analytics; everything
  // else (Create QR, All QR Codes, Users) stays admin-only.
  const visibleLinks = isAdmin
    ? links
    : links.filter((link) => link.to === "/admin" || link.to === "/admin/analytics");

  return (
    <aside className="sidebar">
      <div className="sidebar-section">Menu</div>

      <nav className="sidebar-nav">
        {visibleLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) =>
              `sidebar-link${isActive ? " active" : ""}`
            }
          >
            <span className="sidebar-icon">{link.icon}</span>
            <span className="sidebar-text">{link.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* <div className="sidebar-footer">
        <div className="sidebar-footer-text">QR Studio by myG IT Projects</div>
      </div> */}
    </aside>
  );
}
